import Image from "next/image";

import Marquee from "@/components/magicui/marquee";

interface PartnersSectionProps {
  label: string;
  logos: string[];
}

export default function PartnersSection({ label, logos }: PartnersSectionProps) {
  return (
    <div className="w-full">
      <div className="flex gap-4 md:gap-16 md:items-center px-5 md:px-16 w-full mx-auto flex-col md:flex-row">
        <p className="text-xs font-bold uppercase tracking-[1.1px] text-clay-300 shrink-0">{label}</p>
        <div className="relative w-full overflow-hidden">
          <div className="absolute left-0 top-0 h-full w-16 bg-linear-to-r from-ash-900 to-transparent z-10 pointer-events-none" />
          <div className="absolute right-0 top-0 h-full w-16 bg-linear-to-l from-ash-900 to-transparent z-10 pointer-events-none" />
          <Marquee className="w-full [&>div]:flex [&>div]:items-center [--gap:24px] md:[--gap:64px]" reverse={false}>
            {logos.map((logo, idx) => (
              <Image
                key={idx.toString()}
                src={logo}
                alt={`Partner ${idx + 1}`}
                width={140}
                height={52}
                className="h-8 md:h-14 w-auto opacity-50 grayscale brightness-0 invert"
              />
            ))}
          </Marquee>
        </div>
      </div>
    </div>
  );
}
